import styled, {css} from 'styled-components';

const StyledIcon = styled.i`
  ${({color, code, size, theme}) => css`
    font-family: 'FontTenancyIcon';
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    text-rendering: auto;
    line-height: 1;
    vertical-align: middle;
    position: relative;
    top: -1px;
    font-style: normal;
    font-variant: normal;
    font-weight: 500;

    ${code &&
    css`
      &:before {
        content: '${code}';
      }
    `}

    ${color === 'inherit' &&
    css`
      color: inherit;
    `}

    ${color === 'primary' &&
    css`
      color: ${theme.palette.primary.main};
    `}

    ${color === 'secondary' &&
    css`
      color: ${theme.palette.secondary.main};
    `}

    ${color === 'tertiary' &&
    css`
      color: ${theme.palette.tertiary.main};
    `}

    ${size === 'inherit' &&
    css`
      font-size: inherit;
    `}

    ${size === 'small' &&
    css`
      font-size: ${theme.typography.size.small};
    `}

    ${size === 'medium' &&
    css`
      font-size: ${theme.typography.size.medium};
    `}

    ${size === 'large' &&
    css`
      font-size: ${theme.typography.size.large};
    `}
    ${size &&
    !['large', 'medium', 'inherit', 'small'].includes(size) &&
    css`
      font-size: ${size};
    `}
  `}
`;

export default StyledIcon;
